
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/tableau",
      function () {
        return require("private-next-pages/sources/tableau.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/tableau"])
      });
    }
  